import keymirror from 'keymirror';

export default keymirror({
  GET_ACTIVITY: null,
  GET_ACTIVITY_SUCCESS: null,
  GET_ACTIVITY_ERROR: null,
  RESET: null
});
